import {
  getAccessToken,
  setAccessToken,
  isTokenExpired,
  shouldRefreshToken,
  setPendingOAuthToken,
  getPendingOAuthToken,
  getUserEmail,
  getUserName,
  getUserRoles,
  isBlogAdmin,
  subscribeToAuthChanges,
  isLoggedIn,
  wasLastTokenExpired,
  notifyAuthListeners
} from './token';

import {
  login,
  forgotPassword,
  resetPassword,
  refreshAccessToken,
  bootstrapAuth,
  register,
  completePendingOAuth,
  LoginResult,
  RegisterPayload
} from './api';

export type { LoginResult, RegisterPayload };

export {
  getAccessToken,
  isLoggedIn,
  isTokenExpired,
  wasLastTokenExpired,
  subscribeToAuthChanges,
  setAccessToken,
  setPendingOAuthToken,
  getPendingOAuthToken,
  getUserEmail,
  getUserName,
  getUserRoles,
  isBlogAdmin
};

export {
  login,
  forgotPassword,
  resetPassword,
  refreshAccessToken,
  bootstrapAuth,
  register,
  completePendingOAuth
};

export function logout() {
  setAccessToken(null);
}
